import { Table } from '@vwfs-bronson/bronson-react';
import { Agent } from '../../fes';
import { RowActionsMenu } from '../RowActionsMenu';

export function AgentsTable({
  agents,
  canManageAgent,
  onDeleteAgent,
  onEditAgent,
}: {
  agents: Agent[];
  canManageAgent: (agent: Agent) => boolean;
  onDeleteAgent: (agent: Agent) => void;
  onEditAgent: (agent: Agent) => void;
}) {
  if (agents.length === 0) {
    return <p className="app-empty">No agents found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
            <Table.Th>Availability</Table.Th>
            <Table.Th className="app-table-actions-column">Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {agents.map(agent => (
            <Table.Tr key={agent.agentId || agent.name}>
              <Table.Td>{agent.name}</Table.Td>
              <Table.Td>
                <span className="app-table-description" title={agent.description}>
                  {agent.description || '-'}
                </span>
              </Table.Td>
              <Table.Td>{agent.isGlobal ? 'Global' : agent.teamId ? 'Team' : 'Private'}</Table.Td>
              <Table.Td className="app-table-actions-column">
                <RowActionsMenu
                  disabled={!agent.agentId || !canManageAgent(agent)}
                  disabledReason={
                    !agent.agentId
                      ? 'Agent ID is required for actions'
                      : 'Global agents can only be managed by administrators'
                  }
                  label={`agent ${agent.name || agent.agentId}`}
                  onDelete={() => onDeleteAgent(agent)}
                  onEdit={() => onEditAgent(agent)}
                />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
